var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusImporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1240_32935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.75C3.5 0.79297 4.26562 0 5.25 0H9.62503V3.5C9.62503 3.99219 10.0078 4.375 10.5 4.375H14V12.25C14 13.2344 13.207 14 12.25 14H5.25C4.26562 14 3.5 13.2344 3.5 12.25V9.1875H8.25781L7.1914 10.2539C6.91797 10.5273 6.91797 10.9375 7.1914 11.1836C7.4375 11.457 7.84765 11.457 8.12109 11.1836L10.3086 8.99609C10.5547 8.75 10.5547 8.33984 10.3086 8.06641L8.12109 5.87891C7.84765 5.63281 7.4375 5.63281 7.1914 5.87891C6.91797 6.15234 6.91797 6.5625 7.1914 6.80859L8.25781 7.875H3.5V1.75ZM3.5 7.875V9.1875H0.656253C0.273437 9.1875 0 8.91406 0 8.53125C0 8.17578 0.273437 7.875 0.656253 7.875H3.5ZM14 3.5H10.5V0L14 3.5Z",
    fill: "#598EF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1240_32935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusImporting);
export default __webpack_public_path__ + "static/media/status-importing.b19e6d2dd6d45f20820a20c0402604c7.svg";
export { ForwardRef as ReactComponent };